import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { linkifyGoAndTrack } from "../../lib/goAndTrack";

export default function CTAStrip({
  title = "Ready to deploy disposable smart labels?",
  body = "Talk to a specialist about pilots, integrations, and GoAndTrack workflows.",
  primary = { to: "/request-a-trial", label: "Speak to an expert" },
  variant = "default",
}) {
  const dark = variant === "dark";
  return (
    <section
      data-testid="cta-strip"
      className={`${dark ? "bg-ink text-white" : "bg-surface-subtle text-ink"} border-y border-line`}
    >
      <div className="container-x py-16 lg:py-20 grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
        <div className="md:col-span-8">
          <h2
            className={`font-heading text-3xl sm:text-4xl font-semibold tracking-tight leading-[1.1] ${
              dark ? "text-white" : "text-ink"
            }`}
          >
            {title}
          </h2>
          <p
            className={`mt-4 max-w-xl ${
              dark ? "text-white/70" : "text-ink-muted"
            }`}
          >
            {linkifyGoAndTrack(body)}
          </p>
        </div>
        <div className="md:col-span-4 flex md:justify-end">
          <Link
            to={primary.to}
            className={`btn-primary ${
              dark ? "bg-white text-ink hover:bg-white/90" : ""
            }`}
            data-testid="cta-strip-primary"
          >
            {primary.label} <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
